import { Component, computed, input } from '@angular/core';
import { TStatus } from '../../../../../shared/components/status-chip/status.type';
import { StatusChipComponent } from '../../../../../shared/components/status-chip/status-chip.component';
import { ISample } from '../../interface/sample.interface';

@Component({
  standalone: true,
  imports: [StatusChipComponent],
  selector: 'cpr-sample-status',
  template: '<app-status-chip [value]="status()"  />',
})
export class SampleStatus {
  readonly sample = input.required<ISample>();

  protected readonly status = computed<TStatus>(() => {
    const sample = this.sample();

    if (sample.isFinalised) {
      return 'finalised';
    } else if (sample.submittedAt) {
      return 'submitted';
    } else if (sample.isSubmitting) {
      return 'submitting';
    } else if (sample.isAnalysed) {
      return 'analysing';
    } else {
      return 'created';
    }
  });
}
